import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

export interface FeedPost {
  id: string;
  author: {
    id?: string;
    organizationId?: string;
    name: string;
    avatar?: string;
    initials?: string;
  };
  date: Date;
  categories: string[];
  content: string;
  mediaUrl?: string;
  mediaType?: 'image' | 'video';
  likes: number;
  comments: number;
  isLiked: boolean;
}

export interface RecommendedConnection {
  id: string;
  name: string;
  title: string;
  company: string;
  avatar?: string;
  initials?: string;
  badge?: string;
}

@Injectable({
  providedIn: 'root',
})
export class MockFeedService {
  private mockPosts: FeedPost[] = [
    {
      id: '1',
      author: {
        id: 'follower-1',
        name: 'Sarah Johnson',
        initials: 'SJ',
      },
      date: new Date('2025-01-01T09:04:00'),
      categories: ['IT', 'Construction'],
      content:
        'We are excited to announce our new cloud infrastructure platform that will revolutionize how construction companies manage their projects. This innovative solution combines real-time collaboration with advanced analytics.',
      mediaUrl:
        'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800',
      mediaType: 'image',
      likes: 3,
      comments: 4,
      isLiked: false,
    },
    {
      id: '2',
      author: {
        organizationId: 'org-summit-construction',
        name: 'Summit Construction Group',
        initials: 'SC',
      },
      date: new Date('2025-01-01T08:30:00'),
      categories: ['Construction', 'Medical'],
      content:
        'Our team just completed a state-of-the-art medical facility that incorporates sustainable building practices and cutting-edge technology. The project showcases our commitment to excellence in healthcare construction.',
      mediaUrl:
        'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800',
      mediaType: 'image',
      likes: 12,
      comments: 2,
      isLiked: true,
    },
    {
      id: '3',
      author: {
        id: 'follower-3',
        name: 'Emily Davis',
        initials: 'ED',
      },
      date: new Date('2025-01-01T07:15:00'),
      categories: ['Medical'],
      content:
        'Introducing our latest telemedicine platform that connects patients with healthcare providers seamlessly. This breakthrough technology is making healthcare more accessible than ever before.',
      mediaUrl:
        'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
      mediaType: 'image',
      likes: 8,
      comments: 1,
      isLiked: false,
    },
    {
      id: '4',
      author: {
        id: 'follower-4',
        name: 'David Wilson',
        initials: 'DW',
      },
      date: new Date('2025-01-01T06:45:00'),
      categories: ['IT'],
      content:
        'Our AI-powered analytics platform is helping businesses make data-driven decisions faster than ever. Join thousands of companies already transforming their operations with our technology.',
      mediaUrl:
        'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800',
      mediaType: 'image',
      likes: 15,
      comments: 6,
      isLiked: false,
    },
    {
      id: '5',
      author: {
        organizationId: 'org-buildright',
        name: 'BuildRight Contractors',
        initials: 'BR',
      },
      date: new Date('2025-01-01T05:20:00'),
      categories: ['Construction'],
      content:
        'Proud to announce we have been awarded the Green Building Excellence Award for our sustainable construction practices. Our commitment to environmental responsibility sets us apart in the industry.',
      mediaUrl:
        'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
      mediaType: 'image',
      likes: 22,
      comments: 8,
      isLiked: true,
    },
    {
      id: '6',
      author: {
        organizationId: 'org-healthfirst',
        name: 'HealthFirst Medical Systems',
        initials: 'HF',
      },
      date: new Date('2025-01-01T04:10:00'),
      categories: ['Medical'],
      content:
        'We are expanding our network of medical facilities to serve more communities. Our patient-centered approach ensures the highest quality of care for everyone we serve.',
      mediaUrl:
        'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800',
      mediaType: 'image',
      likes: 18,
      comments: 5,
      isLiked: false,
    },
    {
      id: '7',
      author: {
        organizationId: 'org-cloudsync',
        name: 'CloudSync Technologies',
        initials: 'CS',
      },
      date: new Date('2025-01-01T03:30:00'),
      categories: ['IT'],
      content:
        'New security features now available! Our enterprise cloud platform now includes advanced encryption and multi-factor authentication to keep your data safe and secure.',
      mediaUrl:
        'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800',
      mediaType: 'image',
      likes: 9,
      comments: 3,
      isLiked: false,
    },
    {
      id: '8',
      author: {
        organizationId: 'org-metro-builders',
        name: 'Metro Builders LLC',
        initials: 'MB',
      },
      date: new Date('2025-01-01T02:15:00'),
      categories: ['Construction'],
      content:
        'Breaking ground on our newest commercial development project. This mixed-use facility will bring together retail, office space, and residential units in a modern, sustainable design.',
      mediaUrl:
        'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
      mediaType: 'image',
      likes: 14,
      comments: 7,
      isLiked: true,
    },
    {
      id: '9',
      author: {
        organizationId: 'org-precision-health',
        name: 'Precision Health Partners',
        initials: 'PH',
      },
      date: new Date('2025-01-01T01:00:00'),
      categories: ['Medical'],
      content:
        'Our precision medicine program is helping doctors provide personalized treatment plans based on genetic analysis. This innovative approach is improving patient outcomes across the board.',
      mediaUrl:
        'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800',
      mediaType: 'image',
      likes: 11,
      comments: 4,
      isLiked: false,
    },
    {
      id: '10',
      author: {
        organizationId: 'org-codecraft',
        name: 'CodeCraft Software',
        initials: 'CC',
      },
      date: new Date('2024-12-31T23:45:00'),
      categories: ['IT'],
      content:
        'Happy New Year! We are launching our new developer tools platform that will streamline the software development process. Early access is now available for select partners.',
      mediaUrl:
        'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800',
      mediaType: 'image',
      likes: 25,
      comments: 12,
      isLiked: true,
    },
    {
      id: '11',
      author: {
        organizationId: 'org-techvantage',
        name: 'TechVantage Solutions',
        initials: 'TV',
      },
      date: new Date('2024-12-31T22:30:00'),
      categories: ['IT'],
      content:
        'Excited to share our latest case study on digital transformation in the construction industry. Our platform helped a major contractor reduce project delays by 40% and improve team collaboration.',
      mediaUrl:
        'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800',
      mediaType: 'image',
      likes: 19,
      comments: 7,
      isLiked: false,
    },
    {
      id: '12',
      author: {
        organizationId: 'org-summit-construction',
        name: 'Summit Construction Group',
        initials: 'SC',
      },
      date: new Date('2024-12-31T21:15:00'),
      categories: ['Construction'],
      content:
        'Our latest project features innovative green building techniques that reduce energy consumption by 50%. We are proud to lead the industry in sustainable construction practices.',
      mediaUrl:
        'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
      mediaType: 'image',
      likes: 31,
      comments: 9,
      isLiked: true,
    },
    {
      id: '13',
      author: {
        organizationId: 'org-medcare',
        name: 'MedCare Innovations',
        initials: 'MI',
      },
      date: new Date('2024-12-31T20:00:00'),
      categories: ['Medical'],
      content:
        'We are proud to announce that our telemedicine platform has now served over 100,000 patients. This milestone represents our commitment to making quality healthcare accessible to everyone.',
      mediaUrl:
        'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
      mediaType: 'image',
      likes: 27,
      comments: 11,
      isLiked: false,
    },
    {
      id: '14',
      author: {
        organizationId: 'org-digital-dynamics',
        name: 'Digital Dynamics Inc.',
        initials: 'DD',
      },
      date: new Date('2024-12-31T18:45:00'),
      categories: ['IT'],
      content:
        'Our AI analytics platform now supports real-time data processing for enterprise clients. This breakthrough allows businesses to make instant decisions based on live data streams.',
      mediaUrl:
        'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800',
      mediaType: 'image',
      likes: 16,
      comments: 5,
      isLiked: true,
    },
    {
      id: '15',
      author: {
        organizationId: 'org-buildright',
        name: 'BuildRight Contractors',
        initials: 'BR',
      },
      date: new Date('2024-12-31T17:30:00'),
      categories: ['Construction'],
      content:
        'Breaking ground on our new eco-friendly office complex. This project will feature solar panels, rainwater harvesting, and smart building automation systems.',
      mediaUrl:
        'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800',
      mediaType: 'image',
      likes: 23,
      comments: 8,
      isLiked: false,
    },
    {
      id: '16',
      author: {
        organizationId: 'org-healthfirst',
        name: 'HealthFirst Medical Systems',
        initials: 'HF',
      },
      date: new Date('2024-12-31T16:15:00'),
      categories: ['Medical'],
      content:
        'Our new community health initiative is bringing free health screenings to underserved neighborhoods. Together, we can improve health outcomes for everyone.',
      mediaUrl:
        'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800',
      mediaType: 'image',
      likes: 35,
      comments: 14,
      isLiked: true,
    },
    {
      id: '17',
      author: {
        organizationId: 'org-cloudsync',
        name: 'CloudSync Technologies',
        initials: 'CS',
      },
      date: new Date('2024-12-31T15:00:00'),
      categories: ['IT'],
      content:
        'Introducing our new enterprise collaboration suite. Teams can now work together seamlessly across time zones with real-time synchronization and advanced security features.',
      mediaUrl:
        'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800',
      mediaType: 'image',
      likes: 20,
      comments: 6,
      isLiked: false,
    },
    {
      id: '18',
      author: {
        organizationId: 'org-metro-builders',
        name: 'Metro Builders LLC',
        initials: 'MB',
      },
      date: new Date('2024-12-31T13:45:00'),
      categories: ['Construction'],
      content:
        'Our team completed the structural framework for the new downtown development ahead of schedule. This milestone brings us one step closer to transforming the city skyline.',
      mediaUrl:
        'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800',
      mediaType: 'image',
      likes: 28,
      comments: 10,
      isLiked: true,
    },
    {
      id: '19',
      author: {
        organizationId: 'org-precision-health',
        name: 'Precision Health Partners',
        initials: 'PH',
      },
      date: new Date('2024-12-31T12:30:00'),
      categories: ['Medical'],
      content:
        'New research shows our precision medicine approach is improving treatment outcomes by 35%. We are excited to continue advancing personalized healthcare solutions.',
      mediaUrl:
        'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800',
      mediaType: 'image',
      likes: 17,
      comments: 4,
      isLiked: false,
    },
    {
      id: '20',
      author: {
        organizationId: 'org-codecraft',
        name: 'CodeCraft Software',
        initials: 'CC',
      },
      date: new Date('2024-12-31T11:15:00'),
      categories: ['IT'],
      content:
        'Our open-source contribution to the developer community has reached 10,000 stars on GitHub. Thank you to everyone who has supported our mission to improve developer productivity.',
      mediaUrl:
        'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800',
      mediaType: 'image',
      likes: 42,
      comments: 18,
      isLiked: true,
    },
    {
      id: '21',
      author: {
        name: 'Precision Manufacturing Co.',
        initials: 'PM',
      },
      date: new Date('2025-01-01T10:00:00'),
      categories: ['Manufacturing'],
      content:
        'We are proud to announce our new automated production line that increases efficiency by 60% while reducing waste. This investment in smart manufacturing technology positions us as an industry leader.',
      mediaUrl:
        'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800',
      mediaType: 'image',
      likes: 28,
      comments: 7,
      isLiked: false,
    },
    {
      id: '22',
      author: {
        name: 'Global Finance Partners',
        initials: 'GF',
      },
      date: new Date('2025-01-01T09:45:00'),
      categories: ['Finance'],
      content:
        'Our new investment platform makes it easier than ever for individuals to start building wealth. With low minimums and expert guidance, financial independence is within reach for everyone.',
      mediaUrl:
        'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800',
      mediaType: 'image',
      likes: 35,
      comments: 12,
      isLiked: true,
    },
    {
      id: '23',
      author: {
        name: 'EduTech Solutions',
        initials: 'ET',
      },
      date: new Date('2025-01-01T09:30:00'),
      categories: ['Education'],
      content:
        'We are launching a new online learning platform that brings quality education to students worldwide. Our interactive courses and personalized learning paths help students achieve their academic goals.',
      mediaUrl:
        'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800',
      mediaType: 'image',
      likes: 19,
      comments: 5,
      isLiked: false,
    },
    {
      id: '24',
      author: {
        name: 'GreenFields Agriculture',
        initials: 'GA',
      },
      date: new Date('2025-01-01T09:15:00'),
      categories: ['Agriculture'],
      content:
        'Our sustainable farming practices have resulted in a 40% increase in crop yield while reducing water usage by 30%. We are committed to feeding the world while protecting our planet.',
      mediaUrl:
        'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800',
      mediaType: 'image',
      likes: 31,
      comments: 9,
      isLiked: true,
    },
    {
      id: '25',
      author: {
        name: 'RetailMax Corporation',
        initials: 'RM',
      },
      date: new Date('2025-01-01T09:00:00'),
      categories: ['Retail'],
      content:
        'We are revolutionizing the retail experience with our new omnichannel platform. Customers can now seamlessly shop online, in-store, or through our mobile app with the same great experience.',
      mediaUrl:
        'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800',
      mediaType: 'image',
      likes: 24,
      comments: 8,
      isLiked: false,
    },
    {
      id: '26',
      author: {
        name: 'Advanced Manufacturing Systems',
        initials: 'AM',
      },
      date: new Date('2025-01-01T08:45:00'),
      categories: ['Manufacturing', 'IT'],
      content:
        'Our AI-powered quality control system detects defects with 99.9% accuracy, reducing waste and ensuring every product meets our high standards. This technology is transforming manufacturing.',
      mediaUrl:
        'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=800',
      mediaType: 'image',
      likes: 22,
      comments: 6,
      isLiked: false,
    },
    {
      id: '27',
      author: {
        name: 'Capital Wealth Management',
        initials: 'CW',
      },
      date: new Date('2025-01-01T08:30:00'),
      categories: ['Finance'],
      content:
        'We are excited to introduce our new retirement planning tools that help individuals visualize their financial future. Start planning today to secure a comfortable retirement tomorrow.',
      mediaUrl:
        'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800',
      mediaType: 'image',
      likes: 17,
      comments: 4,
      isLiked: true,
    },
    {
      id: '28',
      author: {
        name: 'Learning Academy Network',
        initials: 'LA',
      },
      date: new Date('2025-01-01T08:15:00'),
      categories: ['Education'],
      content:
        'Our new vocational training programs are helping students gain practical skills for in-demand careers. Over 90% of our graduates find employment within six months of completion.',
      mediaUrl:
        'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800',
      mediaType: 'image',
      likes: 26,
      comments: 10,
      isLiked: false,
    },
    {
      id: '29',
      author: {
        name: 'Sustainable Farms Inc.',
        initials: 'SF',
      },
      date: new Date('2025-01-01T08:00:00'),
      categories: ['Agriculture'],
      content:
        'We are proud to announce our partnership with local communities to provide fresh, organic produce. Our farm-to-table program connects consumers directly with sustainable growers.',
      mediaUrl:
        'https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=800',
      mediaType: 'image',
      likes: 29,
      comments: 11,
      isLiked: true,
    },
    {
      id: '30',
      author: {
        name: 'StyleHub Retail',
        initials: 'SH',
      },
      date: new Date('2025-01-01T07:45:00'),
      categories: ['Retail'],
      content:
        'Our new flagship store features an immersive shopping experience with augmented reality try-ons and personalized styling recommendations. Visit us to see the future of retail.',
      mediaUrl:
        'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800',
      mediaType: 'image',
      likes: 21,
      comments: 7,
      isLiked: false,
    },
    {
      id: '31',
      author: {
        name: 'Industrial Manufacturing Group',
        initials: 'IM',
      },
      date: new Date('2025-01-01T07:30:00'),
      categories: ['Manufacturing'],
      content:
        'We have achieved zero-waste production at our main facility through innovative recycling and process optimization. This milestone demonstrates our commitment to sustainable manufacturing.',
      mediaUrl:
        'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800',
      mediaType: 'image',
      likes: 33,
      comments: 13,
      isLiked: true,
    },
    {
      id: '32',
      author: {
        name: 'FinTech Innovations',
        initials: 'FI',
      },
      date: new Date('2025-01-01T07:15:00'),
      categories: ['Finance', 'IT'],
      content:
        'Our new blockchain-based payment system provides secure, instant transactions with lower fees. This technology is making financial services more accessible and affordable for everyone.',
      mediaUrl:
        'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800',
      mediaType: 'image',
      likes: 38,
      comments: 15,
      isLiked: false,
    },
    {
      id: '33',
      author: {
        name: 'University Online Programs',
        initials: 'UO',
      },
      date: new Date('2025-01-01T07:00:00'),
      categories: ['Education'],
      content:
        'We are expanding our online degree programs to include new fields in technology and healthcare. Earn your degree from anywhere in the world with our flexible, accredited programs.',
      mediaUrl:
        'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800',
      mediaType: 'image',
      likes: 27,
      comments: 9,
      isLiked: true,
    },
    {
      id: '34',
      author: {
        name: 'Organic Harvest Co-op',
        initials: 'OH',
      },
      date: new Date('2025-01-01T06:45:00'),
      categories: ['Agriculture'],
      content:
        'Our cooperative model connects small-scale farmers with urban markets, ensuring fair prices for growers and fresh produce for consumers. Together, we are building a sustainable food system.',
      mediaUrl:
        'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=800',
      mediaType: 'image',
      likes: 30,
      comments: 8,
      isLiked: false,
    },
    {
      id: '35',
      author: {
        name: 'MegaMart Retail Chain',
        initials: 'MM',
      },
      date: new Date('2025-01-01T06:30:00'),
      categories: ['Retail'],
      content:
        'We are launching our new loyalty program that rewards customers with exclusive deals and early access to sales. Join millions of satisfied customers who save with every purchase.',
      mediaUrl:
        'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800',
      mediaType: 'image',
      likes: 25,
      comments: 6,
      isLiked: true,
    },
  ];

  private mockConnections: RecommendedConnection[] = [
    {
      id: '1',
      name: 'John Wilson, AICP',
      title: 'Community Planner',
      company: 'JEO Consulting',
      initials: 'JW',
      badge: 'Top Pro',
    },
    {
      id: '2',
      name: 'Mark Jacobs',
      title: 'Engineer',
      company: 'Folsom Engineering, LLC',
      initials: 'MJ',
    },
    {
      id: '3',
      name: 'Sarah Thompson',
      title: 'Career Counselor',
      company: 'Omaha Public School District',
      initials: 'ST',
    },
  ];

  getPosts(): Observable<FeedPost[]> {
    return of(this.mockPosts).pipe(delay(300));
  }

  getRecommendedConnections(): Observable<RecommendedConnection[]> {
    return of(this.mockConnections).pipe(delay(200));
  }

  getLikedPosts(): Observable<FeedPost[]> {
    const likedPosts = this.mockPosts.filter((post) => post.isLiked);
    return of(likedPosts).pipe(delay(100));
  }

  likePost(postId: string): Observable<boolean> {
    const post = this.mockPosts.find((p) => p.id === postId);
    if (post) {
      if (post.isLiked) {
        post.likes--;
        post.isLiked = false;
      } else {
        post.likes++;
        post.isLiked = true;
      }
    }
    return of(true).pipe(delay(100));
  }

  searchAutocomplete(query: string): Observable<string[]> {
    if (!query || query.length < 2) {
      return of([]);
    }

    const lowerQuery = query.toLowerCase();
    const suggestions: string[] = [];

    // Search in company names
    this.mockPosts.forEach((post) => {
      if (
        post.author.name.toLowerCase().includes(lowerQuery) &&
        !suggestions.includes(post.author.name)
      ) {
        suggestions.push(post.author.name);
      }
    });

    // Search in categories
    const allCategories = ['IT', 'Construction', 'Medical'];
    allCategories.forEach((category) => {
      if (
        category.toLowerCase().includes(lowerQuery) &&
        !suggestions.includes(category)
      ) {
        suggestions.push(category);
      }
    });

    // Add some generic suggestions
    const genericSuggestions = [
      'cloud computing',
      'sustainable construction',
      'telemedicine',
      'AI technology',
      'healthcare innovation',
    ];
    genericSuggestions.forEach((suggestion) => {
      if (
        suggestion.toLowerCase().includes(lowerQuery) &&
        !suggestions.includes(suggestion)
      ) {
        suggestions.push(suggestion);
      }
    });

    return of(suggestions.slice(0, 5)).pipe(delay(200));
  }

  getAISummary(searchTerm: string): Observable<string> {
    // Generate a mock AI summary based on the search term
    const summaries: Record<string, string> = {
      it: 'The IT sector is experiencing rapid growth with companies focusing on cloud infrastructure, AI-powered analytics, and enterprise security solutions. Key trends include digital transformation, automation, and data-driven decision making.',
      construction:
        'Construction companies are embracing sustainable building practices and innovative technologies. Recent developments include green building certifications, smart construction management platforms, and mixed-use commercial developments.',
      medical:
        'The medical industry is advancing through telemedicine platforms, precision medicine programs, and expanded healthcare networks. Patient-centered care and accessibility are driving innovation in healthcare delivery.',
      'cloud computing':
        'Cloud computing continues to revolutionize business operations with enhanced security features, scalable infrastructure, and real-time collaboration tools. Companies are migrating to cloud platforms for improved efficiency.',
      'sustainable construction':
        'Sustainable construction practices are gaining recognition through green building awards and environmental responsibility initiatives. The industry is focusing on eco-friendly materials and energy-efficient designs.',
      telemedicine:
        'Telemedicine platforms are making healthcare more accessible by connecting patients with providers seamlessly. This technology is improving patient outcomes and expanding healthcare reach to underserved communities.',
    };

    const lowerTerm = searchTerm.toLowerCase();
    let summary =
      summaries[lowerTerm] ||
      `Based on your search for "${searchTerm}", here are the key insights: The industry is showing strong growth with innovative solutions and cutting-edge technology. Companies are focusing on digital transformation, sustainability, and customer-centric approaches to drive success.`;

    return of(summary).pipe(delay(500));
  }

  searchPosts(query: string): Observable<FeedPost[]> {
    if (!query) {
      return this.getPosts();
    }

    const lowerQuery = query.toLowerCase();
    const filtered = this.mockPosts.filter(
      (post) =>
        post.author.name.toLowerCase().includes(lowerQuery) ||
        post.content.toLowerCase().includes(lowerQuery) ||
        post.categories.some((cat) => cat.toLowerCase().includes(lowerQuery))
    );

    return of(filtered).pipe(delay(300));
  }
}
